import React from 'react';

type Props = {
  className?: string;
};

const Icon: React.FC<Props> = ({ className }: Props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="29" fill="none" viewBox="0 0 22 29" className={className}>
    <path
      // fill="#000"
      d="M3 28.333a2.568 2.568 0 01-1.883-.783 2.568 2.568 0 01-.784-1.883V12.333c0-.733.261-1.36.784-1.883A2.568 2.568 0 013 9.667h1.333V7c0-1.844.65-3.417 1.95-4.717C7.583.983 9.156.333 11 .333c1.845 0 3.417.65 4.717 1.95 1.3 1.3 1.95 2.873 1.95 4.717v2.667H19c.733 0 1.361.26 1.883.783.523.522.784 1.15.784 1.883v13.334c0 .733-.261 1.36-.784 1.883a2.568 2.568 0 01-1.883.783H3zm0-2.666h16V12.333H3v13.334zm8-4c.733 0 1.361-.262 1.883-.784.523-.522.784-1.15.784-1.883 0-.733-.261-1.361-.784-1.883A2.568 2.568 0 0011 16.333c-.733 0-1.361.261-1.883.784A2.568 2.568 0 008.333 19c0 .733.261 1.361.784 1.883.522.523 1.15.784 1.883.784zm-4-12h8V7c0-1.111-.389-2.056-1.167-2.833C13.056 3.389 12.111 3 11 3c-1.111 0-2.056.389-2.833 1.167C7.389 4.944 7 5.889 7 7v2.667z"
    ></path>
  </svg>
);

export default Icon;
